//importing style
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/styles.scss";

//importing react components
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './tests/reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {I18nextProvider} from "react-i18next";
import i18next from "i18next";

//importing context providers
import {AppDataProvider} from "./context/data";
import {AppStateProvider} from "./context/state";


//importing components
import App from "./App";


//importing translations
//norwegian
import common_no from "./translations/no/common.json";
import errors_no from "./translations/no/errors.json";

//english
import common_en from "./translations/en/common.json";
import errors_en from "./translations/en/errors.json";


export const translationInit = i18next.init({
    interpolation: { escapeValue: false },  // React already does escaping
    lng: 'no',                              // language to use
    resources: {
        en: {
            common: common_en,             // 'common' is our custom namespace
            errors: errors_en
        },
        no: {
            common: common_no,
            errors: errors_no
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
    <React.StrictMode>
        {/*Translation provider for website translations trough i18next*/}
        <I18nextProvider i18n={i18next}>
            {/*AppStateProvider is a contextProvider to provide a global state available across all pages*/}
            <AppStateProvider>
                {/*AppDataProvider is a contextProvider to provide a global data available across all pages*/}
                <AppDataProvider>
                    {/*Router container for website redirects*/}
                    <BrowserRouter>
                        {/*Application render*/}
                        <App/>
                    </BrowserRouter>
                </AppDataProvider>
            </AppStateProvider>
        </I18nextProvider>

    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

